import f from "./ghl-ui.es1577.js";
import m from "./ghl-ui.es1578.js";
import n from "./ghl-ui.es1574.js";
import u from "./ghl-ui.es1575.js";
import c from "./ghl-ui.es1576.js";
import s from "./ghl-ui.es1579.js";
import { Parser as p } from "./ghl-ui.es1658.js";
import { dayPeriodEnumToHours as B } from "./ghl-ui.es1659.js";
var T = /* @__PURE__ */ function(d) {
  u(o, d);
  var a = c(o);
  function o() {
    var e;
    f(this, o);
    for (var t = arguments.length, i = new Array(t), r = 0; r < t; r++)
      i[r] = arguments[r];
    return e = a.call.apply(a, [this].concat(i)), s(n(e), "priority", 80), s(n(e), "incompatibleTokens", ["a", "b", "t", "T"]), e;
  }
  return m(o, [{
    key: "parse",
    value: function(t, i, r) {
      switch (i) {
        case "B":
        case "BB":
        case "BBB":
          return r.dayPeriod(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return r.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return r.dayPeriod(t, {
            width: "wide",
            context: "formatting"
          }) || r.dayPeriod(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(t, i, r) {
      return t.setUTCHours(B(r), 0, 0, 0), t;
    }
  }]), o;
}(p);
export {
  T as DayPeriodParser
};
